import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';

import { Heading } from '@treams/treams-ui';

import * as graphql from 'generated/graphql';

import EngagementQuestion from './EngagementQuestion';

export default function EngagementQuestions(props: {
	questions: graphql.AnalyticsEngagementQuestionScoreTrend[];
}) {
	const { t } = useTranslation();

	return (
		<Box>
			<Heading mb={2}>{t('dashboard.metrics.engagement.questions.title')}</Heading>
			{props.questions.map((trend, i) => (
				<EngagementQuestion key={i} question={trend} first={i === 0} />
			))}
		</Box>
	);
}
